import React from 'react'
import { Link } from 'react-router-dom'

const Login = () => {
  return (
    <div className='block'>
        <div className='loginContainer'>
            <div className="loginRight">
                <h1>Login</h1>
                <p style={{fontSize:"20px"}}>Find the currect job for you!</p>
                <button className="socialBtn">
                    <img height="18" width="18" alt="" src="https://wellfound.com/assets/shared/google-color-f4c1a8513bd15c69ec7ca579db2b03481fc853e34a4de63ceab61c6e7ec2c3c5.svg"/>
                    <span className="social_button_text mx-3">Log in with Google</span>
                </button>
                <div className="or-container">
                <div className="line"></div>
                <span>or Log in with Email</span>
                <div className="line"></div>
                </div>
                <div className='inputContainer'>
                    <div className="label">Email</div>
                    <input className="input" type="text" placeholder='Email' />
                </div>
                <div className='inputContainer'>
                    <div className="label">Passowrd</div>
                    <input className="input" type="text" placeholder='Password' />
                </div>
                <button className='loginBtn'>Log in</button>
                <div className="or-container">
                <div className="line"></div>
                <span>Not registered? <Link to="/signup">Create an account</Link></span>
                <div className="line"></div>
                </div>
            </div>
            <div className="loginLeft">
                <h1>Find the job made for you.</h1>
                <p>Browse over 130K jobs at top companies and fast-growing startups.</p>
            </div>
        </div>
    </div>
  )
}

export default Login
